// app/javascript/components/course/kanban/KanbanBoard.jsx
import React from "react";
import { DndContext, DragOverlay, defaultDropAnimationSideEffects } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

import Column from "./components/Column";
import DragCardPreview from "./components/DragCardPreview";
import StagesForm from "../../stage/Form";

import useKanbanBoardState from "./hooks/useKanbanBoardState";

export default function KanbanBoard(props) {
  const {
    steps, cols, waiting, dragCard, overlaySize, modalStage, showRejected,
    setModal, setShowRejected, sensors, detectCollision,
    handleDragStart, handleDragOver, handleDragEnd,
    openForm, applyServerUpdate, goToList
  } = useKanbanBoardState(props);

  const readOnly = !props.canEdit;

  return (
    <>
      <DndContext
        sensors={sensors}
        collisionDetection={detectCollision}
        onDragStart={readOnly ? undefined : handleDragStart}
        onDragOver={readOnly ? undefined : handleDragOver}
        onDragEnd={readOnly ? undefined : handleDragEnd}
      >
        <div className="d-flex overflow-auto pb-4">
          {steps.map(step => (
            <SortableContext
              key={step.type}
              id={step.type}
              items={(cols[step.type] ?? []).map(h => h._id)}
              strategy={verticalListSortingStrategy}
            >
              <Column
                droppableId={`col-${step.type}`}
                title={step.name}
                required={step.required}
                hits={cols[step.type] ?? []}
                steps={steps}
                openForm={openForm}
                showRejected={showRejected}
                toggleRejected={() => setShowRejected(o => !o)}
                goToList={goToList}
                waiting={waiting}
                isProcessClosed={props.isProcessClosed}
                canEdit={props.canEdit}
              />
            </SortableContext>
          ))}
        </div>

        <DragOverlay
          style={overlaySize}
          dropAnimation={{
            duration:250,
            sideEffects:defaultDropAnimationSideEffects({
              styles:{ active:{ opacity:"0.2" } }
            })
          }}
        >
          {dragCard && <DragCardPreview hit={dragCard} steps={steps} />}
        </DragOverlay>
      </DndContext>

      {modalStage && (
        <Modal isOpen toggle={() => setModal(null)} size="lg" fade={false}>
          <ModalHeader toggle={() => setModal(null)}>
            {modalStage.name || "Gestionar etapa"}
          </ModalHeader>
          <ModalBody>
            <StagesForm
              stage={modalStage}
              applicant={modalStage.applicant}
              courseId={props.courseId}
              postulationId={modalStage.postulation_id || modalStage.applicant.id}
              setApplicanttHit={applyServerUpdate}
              showNotification={props.showNotification}
              updateHit={applyServerUpdate}
              reloadQuery={props.reloadSearch}
              toggleModal={() => setModal(null)}
              isEditing={props.canEdit}
              boardRef={props.boardRef}
            />
          </ModalBody>
        </Modal>
      )}
    </>
  );
}
